<template>
    <el-dialog title="颜色配置" :visible.sync="visibleSync" width="900px" custom-class="color-config-dialog"
        :close-on-click-modal="false" append-to-body @open="onOpen">
        <div class="search-form">
            <span class="form-label">关键字</span>
            <el-input v-model="kw" placeholder="品名颜色 / 德文 / 法文 / 英文" size="small"
                style="width:260px" clearable @keyup.enter.native="search" />
            <el-button type="primary" size="small" @click="search">查询</el-button>
            <el-button size="small" @click="reset">重置</el-button>
            <el-button size="small" type="success" plain @click="openAdd">新增颜色</el-button>
        </div>

        <el-table :data="rows" border stripe v-loading="loading" style="width:100%;margin-top:12px"
            max-height="460" @selection-change="onSelectionChange">
            <el-table-column type="selection" width="50" align="center" />
            <el-table-column prop="品名颜色" label="品名颜色" min-width="150" />
            <el-table-column prop="英文翻译" label="英文翻译" min-width="150" />
            <el-table-column prop="德文翻译" label="德文翻译" min-width="150" />
            <el-table-column prop="法文翻译" label="法文翻译" min-width="150" />
            <el-table-column label="操作" width="130" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="openEdit(scope.row)">编辑</el-button>
                    <el-button type="text" size="mini" style="color:#F56C6C"
                        @click="removeRow(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="text-align:right;margin-top:12px;">
            <el-button v-if="selectedIds.length" size="mini" type="danger" plain
                @click="removeSelected">删除选中（{{ selectedIds.length }}）</el-button>
            <el-pagination background layout="prev, pager, next, total" :total="total"
                :page-size="size" :current-page="page" @current-change="onPageChange"
                style="display:inline-block;margin-left:12px;" />
        </div>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="480px"
            :close-on-click-modal="false" append-to-body>
            <el-form label-width="90px" size="small">
                <el-form-item label="品名颜色" required>
                    <el-input v-model="form['品名颜色']" placeholder="品名中出现的颜色词，如 Pink / 粉 / Rosa"
                        :disabled="editing" />
                </el-form-item>
                <el-form-item label="英文翻译" required>
                    <el-input v-model="form['英文翻译']" placeholder="英文颜色，如 Pink" />
                </el-form-item>
                <el-form-item label="德文翻译">
                    <el-input v-model="form['德文翻译']" placeholder="可为空" />
                </el-form-item>
                <el-form-item label="法文翻译">
                    <el-input v-model="form['法文翻译']" placeholder="可为空" />
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="saving" @click="save">保存</el-button>
            </span>
        </el-dialog>
    </el-dialog>
</template>

<script>
export default {
    name: 'ColorTranslation',
    props: {
        visible: { type: Boolean, default: false },
    },
    data() {
        return {
            kw: '',
            rows: [],
            total: 0,
            page: 1,
            size: 20,
            loading: false,
            selectedIds: [],
            dialogVisible: false,
            dialogTitle: '新增颜色',
            editing: false,
            saving: false,
            form: this.blankForm(),
        };
    },
    computed: {
        visibleSync: {
            get() { return this.visible; },
            set(v) { this.$emit('update:visible', v); },
        },
    },
    methods: {
        blankForm() {
            return { '品名颜色': '', '英文翻译': '', '德文翻译': '', '法文翻译': '' };
        },
        onOpen() {
            this.kw = '';
            this.page = 1;
            this.fetchList();
        },
        fetchList() {
            this.loading = true;
            this.$axios.get('/vue/vue_product/color/list', {
                params: { kw: this.kw, page: this.page, size: this.size }
            }).then(res => {
                this.loading = false;
                if (res.code === 200 && res.data) {
                    this.rows = res.data.rows || [];
                    this.total = res.data.total || 0;
                }
            }).catch(() => { this.loading = false; });
        },
        search() { this.page = 1; this.fetchList(); },
        reset() { this.kw = ''; this.page = 1; this.fetchList(); },
        onPageChange(p) { this.page = p; this.fetchList(); },
        onSelectionChange(sel) { this.selectedIds = sel.map(r => r.id); },
        openAdd() {
            this.form = this.blankForm();
            this.editing = false;
            this.dialogTitle = '新增颜色';
            this.dialogVisible = true;
        },
        openEdit(row) {
            this.form = { '品名颜色': row['品名颜色'], '英文翻译': row['英文翻译'],
                '德文翻译': row['德文翻译'], '法文翻译': row['法文翻译'] };
            this.editing = true;
            this.dialogTitle = '编辑颜色';
            this.dialogVisible = true;
        },
        save() {
            if (!this.form['品名颜色']) return this.$message.warning('品名颜色不能为空');
            if (!this.form['英文翻译']) return this.$message.warning('英文翻译不能为空');
            this.saving = true;
            this.$axios.post('/vue/vue_product/color/save', this.form).then(res => {
                this.saving = false;
                if (res.code === 200) {
                    this.$message.success('已保存');
                    this.dialogVisible = false;
                    this.fetchList();
                } else {
                    this.$message.error((res && res.message) || '保存失败');
                }
            }).catch(() => { this.saving = false; this.$message.error('保存失败'); });
        },
        removeRow(row) {
            this.$confirm('确定删除「' + row['品名颜色'] + '」？', '提示', { type: 'warning' })
                .then(() => this.doDelete([row.id])).catch(() => { });
        },
        removeSelected() {
            this.$confirm('确定删除选中的 ' + this.selectedIds.length + ' 条？', '提示', { type: 'warning' })
                .then(() => this.doDelete(this.selectedIds)).catch(() => { });
        },
        doDelete(ids) {
            this.$axios.post('/vue/vue_product/color/delete', { ids }).then(res => {
                if (res.code === 200) {
                    this.$message.success('已删除');
                    this.fetchList();
                } else {
                    this.$message.error((res && res.message) || '删除失败');
                }
            }).catch(() => this.$message.error('删除失败'));
        },
    },
};
</script>

<style scoped>
.search-form { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.search-form .form-label { font-size: 13px; color: #606266; white-space: nowrap; }
</style>

<!-- 全局样式：弹窗 append-to-body 渲染在 body 下，scoped 深度选择器无法命中 -->
<style>
/* 仅最外层样式适配：弹窗整体上移 80px，内部结构不变 */
.color-config-dialog { margin-top: max(0px, calc(15vh - 80px)) !important; }
</style>
